"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var RenderIf_1 = __importDefault(require("../RenderIf"));
var Layout_1 = __importDefault(require("./styles/Layout"));
var PlayIcon_1 = __importDefault(require("./styles/PlayIcon"));
var SpinnerIcon_1 = __importDefault(require("./styles/SpinnerIcon"));
var Scene = function (_a) {
    var _b;
    var playButtonColor = _a.playButtonColor, controller = _a.controller, canPlayVideo = _a.canPlayVideo, isEditPage = _a.isEditPage, videoRef = _a.videoRef, inTransition = _a.inTransition, playingSecondVideo = _a.playingSecondVideo, handlePlayVideoClick = _a.handlePlayVideoClick;
    var handlePlayVideo = function (event) {
        var element = event.target;
        if (element.tagName !== 'DIV')
            return;
        if (!canPlayVideo)
            return;
        if (isEditPage)
            return;
        handlePlayVideoClick();
    };
    var handleFullscreenMode = function (event) {
        if (!isEditPage)
            controller === null || controller === void 0 ? void 0 : controller.handleFullscreenMode(event);
    };
    // show if played had no leng
    var noPlayedLength = !((_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.played.length) && !playingSecondVideo;
    return (jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: (noPlayedLength) && !inTransition }, { children: jsx_runtime_1.jsxs(Layout_1.default, __assign({ onClick: handlePlayVideo, onDoubleClick: handleFullscreenMode }, { children: [jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !canPlayVideo }, { children: jsx_runtime_1.jsx(SpinnerIcon_1.default, { spinnerBackgroundColor: playButtonColor }, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: canPlayVideo }, { children: jsx_runtime_1.jsx(PlayIcon_1.default, { playButtonColor: playButtonColor, onClick: handlePlayVideoClick }, void 0) }), void 0)] }), void 0) }), void 0));
};
exports.default = Scene;
